module.exports = __webpack_public_path__ + "static/media/gallery02.a970436e.jpg";